import './App.css';
import React, { Component } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { messages ,options , severProperties} from './utility/Constants';
import { FormattedMessage, IntlProvider } from 'react-intl';
import FormErrors from "./utility/FormErrors";
import Validate from "./utility/FormValidation";
import { useNavigate } from 'react-router';
import { resetUserSession, setUserSession,getLocaleLanguage } from './AuthService';


class Login extends Component {

  constructor(props) {
    super(props);
    resetUserSession();
    this.state =
    {
      locale: 'en',
      referenceId: '',
      password: '',
      errorMessage: '',
      errors: {
        cognito: null,
        blankfield: false,
      }
    };
    this.handleLanguageChange=this.handleLanguageChange.bind(this);
  }

  onInputChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
    document.getElementById(event.target.id).classList.remove("is-danger");
  }

  componentDidMount() {
      this.setState({ locale: getLocaleLanguage() });
  }

  componentWillUnmount() {
      this.setState({ locale: getLocaleLanguage() });
  }
    
  handleLanguageChange = (e) => {
       this.setState({ locale: e.target.value });
       localStorage.setItem('laguagePrefered',e.target.value);
  };

  clearErrorState = () => {
    this.setState({
      errors: {
        cognito: null,
        blankfield: false,
      }
    });
  }

  handleLogin = async (event) => {
    event.preventDefault();
    this.setState({ errorMessage: '' });

    // Form validation
    this.clearErrorState();
    const error = Validate(event, this.state);
    if (error) {
      this.setState({
        errors: { ...this.state.errors, ...error }
      });
    }

    let formData = new FormData();
    formData.append('aplReferenceId', this.state.referenceId);
    formData.append('passportNumber', this.state.password);

    let status;
    if (this.state.referenceId !== "" && this.state.password !== "") {
      
      fetch([severProperties.serverURL,"/auth/login"].join(""), {
        method: "POST",
        headers: {
          'Access-Control-Allow-Origin': severProperties.serverCORS,
          'Access-Control-Allow-Methods': 'POST'
        },
        body: formData,
      })
        .then((response) => { status = response.status; return response.text(); } )
        .then((result) => {
           if (status=== 412 || status=== 403 || status!== 200 || result === "") {
            this.setState({ errorMessage: <div style={{color:'white',backgroundColor:'red',padding:5,alignContent:'justify'}}><FormattedMessage id="cantfinddoc" /></div> });
          }
          else {
            setUserSession(result, '', this.state.referenceId);
            this.props.navigate('/verifyUser');
          }
        }).catch((error)=>{
          this.setState({ errorMessage: <div style={{color:'white',backgroundColor:'red',padding:5,alignContent:'justify'}}>We're experiencing connectivity issues. Please check your network settings or try again later. If the problem persists, contact support for assistance.          </div>}); 
        });
    }
  };
  render() {
    return (
      <div className="main-div">
        <center>
      <div className="gfg-div">
        <div className="gfg-logo"></div>
     <IntlProvider locale={this.state.locale}
        messages={messages[this.state.locale]}  defaultLocale="en" onError={(error) => { /* Handle missing message... */ }}>
          <div className="gfg-title">JIMS Applicant Portal</div>
          <div className="gfg-sub-title">Let's get started by filling out the form below</div>
          
          <div className="gfg-input-fields">
            <div className="gfg-email">
              <div className="floating-label-group">
                <TextField className="input" id="referenceId" value={this.state.referenceId} onChange={this.onInputChange} label={<FormattedMessage id="ReferenceID" />} variant="outlined" style={{ width: "100%" }} />
              </div>
              <span className="icon is-small is-left">
                <i className="fas fa-lock"></i>
              </span>
            </div>
            <div className="gfg-password">
              <div className="floating-label-group">
                <TextField className="input" type="password" id="password" value={this.state.password} onChange={this.onInputChange} label={<FormattedMessage id="PassportNumber" />} variant="outlined" style={{ width: "100%" }} />
              </div>
              <span className="icon is-small is-left">
                <i className="fas fa-lock"></i>
              </span>
            </div>
            <FormErrors formerrors={this.state.errors} />
            {this.state.errorMessage &&
              <center><h6 className="error"> {this.state.errorMessage} </h6></center>}
          </div>
          <Button variant="contained" className="gfg-button" onClick={this.handleLogin}>{<FormattedMessage id="SignIn" />}</Button>
          <div style={{ marginTop: 40 }}>
        <select onChange={this.handleLanguageChange}
                    value={this.state.locale} style={{width:'98%',height:'40px',borderBlockStyle:'dotted',boxShadow:'-moz-initial',borderColor:'blue',borderRadius:4,marginBottom:20}}>
                      {options.map(option=>
                        (<option key={option.label} value={option.value}>{option.label}</option>)
                      )
                      }
                    </select></div>
                    
        </IntlProvider>
      </div>
      </center> 
      </div>
    );
  }
}

function addHookTo(Component) {
  function CompWithHook(props) {
    const navigate = useNavigate();

    return <Component {...props} navigate={navigate} />;
  }

  return CompWithHook;
}

export default addHookTo(Login);